<section class="section" [ngClass]="classes" [ngStyle]="styleProps">
  <ng-content></ng-content>
</section>
